// src/axios.js
import axios from 'axios';
import { useLoaderStore } from './stores/loader.js';
import { showToast } from './eventBus.js';
import router from './router'; // Ajuste o caminho conforme sua estrutura
import { refreshAccessToken } from './tokenService';

let startTime;
const MIN_DISPLAY = 1000; // 3 segundos em milissegundos

const api = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL, // URL da API Spring Boot
  timeout: 50000, // 50 segundos
  headers: {
    'Content-Type': 'application/json', // Certifique-se que o tipo de conteúdo está correto
  },
});

// helpers.js
export function stopLoaderComTempo(loader) {
  const elapsed = Date.now() - startTime;
  const remaining = MIN_DISPLAY - elapsed;
  if (remaining > 0) {
    setTimeout(() => loader.stop(), remaining);
  } else {
    loader.stop();
  }
}

export function forceStopLoader(loader) {
  startTime = 0;
  loader.stop();
}

function logout() {
  localStorage.removeItem('token')
  localStorage.removeItem('refreshToken')
}
// Interceptador para adicionar o token JWT nas requisições (caso necessário)

api.interceptors.request.use(config => {
  const loader = useLoaderStore();
  loader.start();
  startTime = Date.now();

  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});


api.interceptors.response.use(
  response => {
    const loader = useLoaderStore();
    stopLoaderComTempo(loader);
    return response;
  },
  async error => {
    const loader = useLoaderStore();
    stopLoaderComTempo(loader);

    const originalRequest = error.config;
    const status = error.response?.status;

    const isRefreshRequest = originalRequest.url.includes('/auth/refresh');

    if (status === 401 && !originalRequest._retry && !isRefreshRequest) {
      originalRequest._retry = true;

      try {
        const newToken = await refreshAccessToken(); // tenta renovar
        if (newToken) {
          originalRequest.headers.Authorization = `Bearer ${newToken}`;
          return api(originalRequest); // tenta novamente o request original
        } else {
          // Aqui é o caso em que o refresh falha
          logout();
          showToast('Sessão expirada. Faça login novamente.');
          router.push('/');
        }
      } catch (e) {
        forceStopLoader(loader);
        logout();
        showToast('Sessão expirada. Faça login novamente.');
        router.push('/');
      }
    }

    return Promise.reject(error);
  }
);

export default api;
